export default __webpack_public_path__ + "static/media/na-building-image.d96e891d.png";